import { IDomainResource } from '../Resource';
import { IElement } from '../Element';
import { Extension, IExtensionValueDecimal, IExtensionValueBoolean } from '.';
import { IBackboneElement } from '../BackboneElement';

export const getExtensions = (resource: IDomainResource<any> | IElement) =>
  resource.extension;

export const getExtension = (
  resource: IDomainResource<any> | IElement,
  extension: string | Extension,
) => {
  const exts = getExtensions(resource);
  if (!exts) {
    return [];
  }
  if (typeof extension === 'string' || extension instanceof String) {
    return exts.filter(ext => ext.url === extension);
  }
  return exts.filter(ext => ext.url === extension.url);
};

export const getFirstExtension = <ExtensionType extends Extension>(
  resource: IDomainResource<any> | IElement,
  extension: string | ExtensionType,
) => {
  const exts = getExtensions(resource);
  if (!exts) {
    return undefined;
  }
  if (typeof extension === 'string' || extension instanceof String) {
    return exts.filter(ext => ext.url === extension)[0] as ExtensionType;
  }
  return exts.filter(ext => ext.url === extension.url)[0] as ExtensionType;
};

export const getModifierExtensions = (
  resource: IDomainResource<any> | IBackboneElement,
) => resource.modifierExtension;

export const getModifierExtension = (
  resource: IDomainResource<any> | IBackboneElement,
  extension: string | Extension,
) => {
  const exts = getModifierExtensions(resource);
  if (!exts) {
    return [];
  }
  if (typeof extension === 'string' || extension instanceof String) {
    return exts.filter(ext => ext.url === extension);
  }
  return exts.filter(ext => ext.url === extension.url);
};

export const extensionExists = (
  resource: IDomainResource<any> | IElement,
  extension: Extension,
) => {
  const ext = getExtension(resource, extension);
  return !!ext && ext.some(e => e.url === extension.url);
};

export const modifierExtensionExists = (
  resource: IDomainResource<any> | IBackboneElement,
  extension: Extension,
) => {
  const ext = getModifierExtension(resource, extension);
  return !!ext && !!extension.url;
};

export const createDecimalExtension = (
  url: string,
  value: number,
): IExtensionValueDecimal => ({
  url,
  valueDecimal: value,
});

export const createBooleanExtension = (
  url: string,
  value: boolean | undefined,
): IExtensionValueBoolean => ({
  url,
  valueBoolean: !!value,
});
